import PropTypes from 'prop-types'
import React from 'react'

const ReEnterBankPopup = ({ onConfirm }) => {
  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
      <div className='bg-white rounded-xl shadow-xl p-6 w-full max-w-md mx-4'>
        <h2 className='text-lg font-semibold mb-4 text-center text-gray-800'>
          Update Required
        </h2>
        <p className='text-sm text-gray-600 mb-6 text-center'>
          We’ve recently updated our payment system. To continue using the
          platform, please re-enter your bank details to authorize the new
          Pre-Authorized Debit (PAD) agreement.
        </p>
        <div className='flex justify-center'>
          <button
            onClick={onConfirm}
            className='px-5 py-2 rounded-lg bg-primary text-white hover:bg-blue-700 transition'
          >
            Re-Enter Bank Details
          </button>
        </div>
      </div>
    </div>
  )
}

ReEnterBankPopup.propTypes = {
  onConfirm: PropTypes.func.isRequired,
}

export default ReEnterBankPopup
